export type IModalBindings = IDCA.IGenericFunc;

export function _modalBindings(): void {
  $('body')
    .on('click', '.show-static-data-modal', (e) => {
      e.preventDefault();
      $('.view-data-modal').modal('show');
    })
    .on('show.bs.modal', '.view-image-modal', function showBsModal(e) {
      window.DexeroCoreApp._getImageForViewImageModal(this, $(e.relatedTarget));
    })
    .on('hidden.bs.modal', '.view-image-modal', function hiddenBsModal() {
      window.DexeroCoreApp._resetViewImageModal(this);
    })
    .on('show.bs.modal', '.crop-image-modal', function showBsModal(e) {
      window.DexeroCoreApp._getImageForCropImageModal(this, $(e.relatedTarget));
    })
    .on('hidden.bs.modal', '.crop-image-modal', function hiddenBsModal() {
      window.DexeroCoreApp._resetCropImageModal(this);
    })
    .on('show.bs.modal', '.password-modal', function showBsModal(e) {
      window.DexeroCoreApp._getPasswordContent(this, $(e.relatedTarget));
    })
    .on('click', '.reset-user-password', function click() {
      window.DexeroCoreApp.resetUserPassword($(this));
    })
    .on('hidden.bs.modal', '.view-data-modal', function hiddenBsMOdal() {
      window.DexeroCoreApp._resetViewDataModal($(this));
    })
    .on('click', '.view-data-in-modal-button', (e) => {
      e.preventDefault();
      window.DexeroCoreApp.handleViewDataModalClick($(e.currentTarget));
    })
    // Trap tab key into modal
    .on('shown.bs.modal', window.DexeroCoreApp.setupModal)
    // Focus modal trigger element on modal close
    .on('hidden.bs.modal', () => {
      if (window.DexeroCoreApp.lastModalTrigger) {
        (window.DexeroCoreApp.lastModalTrigger as JQuery<HTMLElement>).focus();
      }
    });
}
